var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaceholderImage = function SvgPlaceholderImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280,
    height: 150
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "placeholder-image_svg__a",
    d: "M0 0h280v150H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "placeholder-image_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#placeholder-image_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#placeholder-image_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ECECEC",
    strokeWidth: 1.5,
    d: "M350.43 76.098c5.5 3.125-99.758 54.122-190.043 40.637-46.159-6.894-60.263-18.454-68.006-32.528-3.663-6.658-2.209-24.322-1.967-31.868.03-.9.021-1.896.686-2.505.551-.507 1.37-.557 2.118-.58 29.26-.898 58.546-.953 87.81-.165.775.02 1.416.602 1.525 1.37.218 1.545.121 3.483-.364 5.68a3.036 3.036 0 0 1-.475 1.08c-1.856 2.665-3.918 5.651-6.083 8.01-2.973 3.239-9.308 11.433-12.72 13.443-2.197 1.294-5.578.123-3.727-1.667 3.069-2.967 7.896 2.206 20.804.59.88-.11 2.327-.205 2.521.66.494 2.198.148 4.327-.33 6.441-.106.466-.585.85-1.063.856l-24.001.294c-2.266.027-5.683.388-6.22-.66-.785-1.534-.41-5.613.152-6.575 1.41-2.42 12.605-13.464 18.456-21.494.173-.238.028-.57-.265-.581-8.809-.33-17.973-.47-26.87.067-.801.049-1.677.13-2.248.692-.669.657-.597 1.714-.632 2.65-.37 9.9-.969 27.744 2.895 29.053 2.752.932 2.417-3.612.14-4.288-1.942-.576-3.864-.434-5.887-.34-2.022.093-5.564.375-6.176-.411-.392-.503-.142-3.795-.126-5.11l.245-20.698a1.765 1.765 0 0 0-1.751-1.785l-27.982-.237a1.2 1.2 0 0 0-1.207 1.098 48.425 48.425 0 0 0-.137 5.115c.011.52.444.93.964.921 5.206-.094 10.416.023 15.612.35.196.013.346.181.335.377l-.324 6.005a.361.361 0 0 1-.35.337c-4.753.073-9.846.28-15.125-.1-.18-.013-.4.085-.391.265l.005 5.268c.003 3.007-.767 5.977-2.309 8.56-5.445 9.12-24.726 9.12-45.93 3.028-15.87-4.56-21.252-10.233-27.777-18.385C11.985 53.692 17.46 35.96 28.36 32.38c16.19-5.315 24.65 5.757 24.65 15.596 0 19.454-23.317 26.36-27.635 26.796-29.608 2.985-59.979-12.025-88.594-3.86-7.176 2.048-13.868 5.484-20.435 9.028-3.92 2.115-7.815 4.277-11.71 6.438",
    mask: "url(#placeholder-image_svg__b)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#A8A8A8",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 13,
    fontWeight: 500,
    mask: "url(#placeholder-image_svg__b)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 90,
    y: 111
  }, "Billede mangler")))));
};
export { SvgPlaceholderImage as ReactComponent };
export default __webpack_public_path__ + "9e4846f7f506521e3b7d05b43f53ed35.svg";